import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import React from "react";
import { tagMessage } from "../utils";
import PlatformConstants from "../PlatformConstants";
import createHandler from "./createHandler";
import { baseGestureHandlerProps } from "./gestureHandlerCommon";
export var forceTouchGestureHandlerProps = [
    "minForce",
    "maxForce",
    "feedbackOnActivation"
];
var _React_Component;
// implicit `children` prop has been removed in @types/react^18.0.0
var ForceTouchFallback = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ForceTouchFallback, _superClass);
    var _super = _create_super(ForceTouchFallback);
    function ForceTouchFallback() {
        _class_call_check(this, ForceTouchFallback);
        return _super.apply(this, arguments);
    }
    _create_class(ForceTouchFallback, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                console.warn(tagMessage("ForceTouchGestureHandler is not available on this platform. Please use ForceTouchGestureHandler.forceTouchAvailable to conditionally render other components that would provide a fallback behavior specific to your usecase"));
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return ForceTouchFallback;
}(_React_Component = React.Component);
_define_property(ForceTouchFallback, "forceTouchAvailable", false);
export var forceTouchHandlerName = "ForceTouchGestureHandler";
// eslint-disable-next-line @typescript-eslint/no-redeclare -- backward compatibility; see description on the top of gestureHandlerCommon.ts file
export var ForceTouchGestureHandler = (PlatformConstants === null || PlatformConstants === void 0 ? void 0 : PlatformConstants.forceTouchAvailable) ? createHandler({
    name: forceTouchHandlerName,
    allowedProps: _to_consumable_array(baseGestureHandlerProps).concat(_to_consumable_array(forceTouchGestureHandlerProps)),
    config: {}
}) : ForceTouchFallback;
ForceTouchGestureHandler.forceTouchAvailable = (PlatformConstants === null || PlatformConstants === void 0 ? void 0 : PlatformConstants.forceTouchAvailable) || false;
